import { Expose } from 'class-transformer'
import { BookChapterCampaign } from './BookChapterCampaign'

export class BuyAllBookChapterReaderType {
  @Expose() id: number

  @Expose() chapterName: string

  @Expose() chapterTitle: string

  @Expose() price: number

  @Expose() chapterCampaign: BookChapterCampaign
}
